module.exports = __webpack_public_path__ + "img/facebook.61f23eb5.svg";